// import Flickity from 'flickity';
Flickity.prototype._createResizeClass = function () {
    this.element.classList.add('flickity-resize');
};

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
    this.element.classList.remove('flickity-resize');
    resize.call(this);
    this.element.classList.add('flickity-resize');
};
if (!customElements.get('lsg-logos')) {
    customElements.define('lsg-logos', class LSGLogos extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                slider: ".js-lsg-logos-slider",
                sliderScrolling: ".js-lsg-logos-scrolling",
                wrap: ".js-lsg-logos-slider-wrap",
                item: ".js-lsg-logos-slider .js-lsg-logos-slider-item"
            };
            this.slider = this.querySelector(this.selectors.slider);
            this.sliderScrolling = this.querySelector(this.selectors.sliderScrolling);
            this.wrap = this.querySelector(this.selectors.wrap);
            this.items = this.querySelectorAll(this.selectors.item)
            this.init();
        }

        init() {
            this.setWidth();
            this.initSlider();
            window.addEventListener('resize', () => {
                if (this.slider != null) {
                    if (this.slider.classList.contains('flickity-enabled')) {
                        this.setWidth();
                    }
                }
            });

            // Section loaded in Theme Editor
            document.addEventListener('shopify:section:load', function (event) {
                const $parent = $(event.target);
                let check = $parent.find(`${parent}`);
                if (check.length > 0) {
                    if (this.slider != null) {
                        this.initSlider();
                    }
                }
            });
        }

        setWidth() {
            if (this.wrap != null) {
                let width = 0;
                this.items.forEach(item => {
                    width += item.offsetWidth;
                })
                this.wrap.style.maxWidth = width + 'px';
            }
        }

        setupSlider(slider) {
            let index = 0;
            const slides = slider.element.querySelectorAll('.js-lsg-logos-slider-item');
            slides.forEach((el) => {
                index++;
                el.setAttribute('aria-label', `slide ${index} of ${slides.length}`);
                el.setAttribute('role', 'group');
            });
        }

        initSlider() {
            const self = this;
            if (this.sliderScrolling != null) {
                const props_marquee = new Flickity(this.sliderScrolling, {
                    accessibility: false,
                    resize: true,
                    wrapAround: true,
                    prevNextButtons: false,
                    pageDots: false,
                    percentPosition: true,
                    setGallerySize: true,
                    contain: true,
                    cellAlign: "left",
                    on: {
                        ready: function () {
                            self.setupSlider(this);
                        }
                    }
                });
                props_marquee.x = 0;
                play();

                function play() {
                    props_marquee.x -= 0.3;
                    props_marquee.settle(props_marquee.x);
                    let requestId = window.requestAnimationFrame(play);
                }
            }

            if (this.slider != null) {
                const slider = new Flickity(this.slider, {
                    cellAlign: "left",
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: true,
                    accessibility: false,

                    on: {
                        ready: function () {
                            self.setupSlider(this);
                        }
                    }
                });


                slider.resize()
            }
        }


    })
}

